module.exports = __webpack_public_path__ + "media/images/demo_tests/theswitch-3a7c2780f436003e10a3fa3dc38e06a4.png";